import { GetServerSidePropsContext } from "next"

// 获取制定 url 地址的根域名 或者 子域名
export function getDomain(url: string, subdomain?: boolean) {
  subdomain = subdomain || false

  url = url.replace(/(https?:\/\/)?(www.)?/i, "")

  if (!subdomain) {
    const urlAry = url.split(".")

    url = urlAry.slice(urlAry.length - 2).join(".")
  }

  if (url.indexOf("/") !== -1) {
    return url.split("/")[0]
  }

  return url
}

export const getHost = (ctx: GetServerSidePropsContext) => {
  return ctx.req.headers['x-forwarded-host'] || ctx.req.headers.host
}

// 不包含，开发，测试，预发布环境本身子域名
const envHost = ['test', 'dev', 'stage', 'prod', 'www', 'local']
export const host2namespace = (host: string) => {
  if (host.startsWith('http')) {
    host = host.replace(/(https|http):\/\//gi, '')
    console.warn('host2namespace 方法入参避免使用https/http开头的链接，取值推荐location.origin')
  }
  const hostArr = host.split('.')
  if (hostArr.length < 3 || hostArr.length > 3) {
    return ""
  } else {
    const namespace = hostArr[0]
    if (envHost.includes(namespace)) {
      return ''
    } else {
      return namespace
    }
  }
}

export const getOriginByServer = (ctx: GetServerSidePropsContext) => {
  return 'https://' + (ctx.req.headers["x-forwarded-host"] || ctx.req.headers["host"])
}

/**
 * 
 * @returns [namespace: string, location: string]
 * 
 */
export const getNamespaceAndLocationByServer = (context: GetServerSidePropsContext) => {
  const _location =
    (context.req.headers['x-forwarded-host'] || context.req.headers.host) as string
  const namespace = (host2namespace(_location as string) || '') as string
  return [namespace, _location]
}

export const getUserAgentByServer = (context: GetServerSidePropsContext) => {
  return context.req.headers['user-agent']
}